import './index.less';
import * as React from 'react';
import PropTypes from 'prop-types';
import Resizable from 're-resizable';
import { Icon, Tabs } from '@beehive/components';
import _ from 'lodash';
import classnames from 'classnames';
import { blockDrawerClose } from 'components'

export interface BottomProps {
  prefixCls: string;
  onResize: any;
  getBottomTabElement?: any;
  resizeAble?: boolean;
}

const BOTTOM_MIN_HEIGHT = 300;
const BOTTOM_MAX_HEIGHT = window.innerHeight - 136;

class Bottom extends React.Component<BottomProps, any> {
  public static contextTypes = {
    inSingle: PropTypes.bool,
    detail: PropTypes.object,
  };

  public static childContextTypes = {
    prefixCls: PropTypes.string,
  };

  public getChildContext() {
    const { prefixCls } = this.props;
    return {
      prefixCls: `${prefixCls}-bottom`,
    };
  }

  constructor(props: BottomProps) {
    super(props);
    this.state = {
      activeTabKey: undefined,
    };
  }

  public componentDidMount() {
    const { onResize } = this.props;
    this.setBottomHeight();
    // 为了解决切换需求详情和状态进度时高度计算错误的问题
    setTimeout(() => {
      onResize(true)
      this.setBottomHeight();
    }, 1000);
  }

  public componentDidUpdate() {
    this.setBottomHeight()
  }

  private setBottomHeight = () => {
    const { prefixCls, resizeAble = false } = this.props;
    const resizeEnable = (this.getResizeEnable() || resizeAble);
    const bottomMaxHeight = BOTTOM_MAX_HEIGHT;
    const bottomClass = `${prefixCls}-bottom`;
    const activeTabpaneClass = `div.beehive-tabs-tabpane-active`;
    const ele = document.querySelector(`.${bottomClass}`);
    const scrollPart = document
      .querySelector(`.${bottomClass} ${activeTabpaneClass} .${bottomClass}-tab-content-wrapper-scroll-part > div`);

    if (ele && scrollPart) {
      const maxHeight = ele.clientHeight - scrollPart.clientHeight + scrollPart.scrollHeight;
      // @ts-ignore
      ele.style.maxHeight = (maxHeight > bottomMaxHeight ? bottomMaxHeight : maxHeight) + 'px';
    } else if (ele instanceof HTMLElement && !resizeEnable) {
      ele.style.height = 'auto';
    }
  }

  private handleChangeTab = (activeKey: string) => {
    const { onResize } = this.props;
    if (this.state.activeTabKey !== activeKey) {
      this.setState({ activeTabKey: activeKey }, () => {
        // 为了解决切换需求详情和状态进度时高度计算错误的问题
        onResize(true);
        // 第二次出发是因为，onResize(true)之后detail的body高度计算不正确
        // 用onResize(true)将底部高度撑到最大之后，需要再一次调整detail的body高度
        setTimeout(() => {
          onResize();
          this.setBottomHeight()
        }, 40);
      });
    }
    // 判断弹框是否在编辑
    // blockDrawerClose(() => {
      
    // })
  }

  private getResizeEnable = () => {
    const { detail: { state } } = this.context;
    const { activeTabKey } = this.state;
    switch (state) {
      case 'pending_quote':
        return true;
      case 'making':
        return true;
      case 'submit_reimburse':
        return true;
      default:
        return false;
    }
  }

  public render() {
    const { inSingle, detail, detail: { bottom_tabs } } = this.context;
    const { prefixCls, onResize, getBottomTabElement, resizeAble = false } = this.props;
    const isFullHeightTab = ['supplierSubmissionKol'].includes(detail?.bottom_tabs?.[0]?.value);

    // onResize添加防抖
    const debouncedOnResize = _.debounce(onResize, 100, { leading: false, trailing: true });

    const firstTab = _.get(detail, 'bottom_tabs[0].value');
    const { activeTabKey = firstTab } = this.state;
    if (!firstTab) {
      return null;
    }
    let tabElement: any = null;
    try {
      if (getBottomTabElement) {
        tabElement = getBottomTabElement(activeTabKey);
      }
      if (!tabElement) {
        tabElement = require(`./${_.upperFirst(activeTabKey)}/index`).default;
      }
    } catch (err) {
      return null;
    }
    const className = classnames(`${prefixCls}-bottom`, {
      'in-single': inSingle,
    });
    const resizeEnable = (this.getResizeEnable() || resizeAble);

    return (
      <Resizable
        className={className}
        style={{ position: 'absolute' }}
        minHeight={resizeEnable ? BOTTOM_MIN_HEIGHT : 170}
        enable={{ top: resizeEnable }}
        onResize={debouncedOnResize}
        onResizeStop={debouncedOnResize}
      >
        <Tabs
          type="card"
          activeTabKey={activeTabKey || firstTab}
          onChange={this.handleChangeTab}
          className={classnames({
            'mpc-bottom-tabs-full-height': isFullHeightTab,
          })}
        >
          {
            bottom_tabs.map((tab: any) => {
              return (
                <Tabs.TabPane tab={tab.tab_name} key={tab.value}>
                  {
                    React.createElement(tabElement, {
                      key: `${detail.id}-${tab.value}`,
                      tabKey: tab.value,
                    })
                  }
                </Tabs.TabPane>
              );
            })
          }
        </Tabs>
        {resizeEnable && <Icon className="bottom-drag-btn" name="reorder-o" size="small" />}
      </Resizable>
    );
  }
}

export default Bottom;
